import {
  ICreateEditPaymentLink,
  IViewPaymentLink,
  IViewProduct,
} from "../../../interfaces-and-types";
import { View } from "./View";

export interface IPaymentLinkPreviewProps {
  paymentLinkToPreview: ICreateEditPaymentLink;
  productsInPaymentLink: IViewProduct[];
}

export const PaymentLinkPreview = (props: IPaymentLinkPreviewProps) => {
  // console.log(
  //   `PaymentLinkPreview links to map:`,
  //   props.paymentLinkToPreview?.line_items
  // );

  const paymentLinkToPreviewWithMappedProducts: IViewPaymentLink = {
    ...props.paymentLinkToPreview,

    id: "",
    // tx_ref: "",
    // sw_app_tx_ref: "",
    // merchant_name: null,
    // merchant_logo_url: null,
    // show_payment_providers: false,
    link_url: "",
    link_url_with_hostname: "",
    amount: 0,

    created_at: "",
    edited_at: "",

    is_delete_locked: false,
    is_shadow_deleted: false,

    instagram_url: props.paymentLinkToPreview?.instagram_url || "",
    facebook_url: props.paymentLinkToPreview?.facebook_url || "",
    whatsapp_url: props.paymentLinkToPreview?.whatsapp_url || "",
    live_webhook_url: props.paymentLinkToPreview?.live_webhook_url || "",
    test_webhook_url: props.paymentLinkToPreview?.test_webhook_url || "",

    line_items:
      props.paymentLinkToPreview?.line_items
        .filter((p) => p.product !== "")
        .map((item) => {
          // console.log(`getting product for ${item.product}...`);

          const product = props.productsInPaymentLink.find(
            (p) => p.id === item.product
          )!;

          return {
            ...item,
            ...product,
            product_icon: product.product_icon || "",
            description: product.product_description || "",
          };
        }) || [],
  };

  // console.log(
  //   `paymentLinkToPreviewWithMappedProducts map result:`,
  //   paymentLinkToPreviewWithMappedProducts
  // );

  return (
    <View
      {...props}
      paymentLinkToPreviewWithMappedProducts={
        paymentLinkToPreviewWithMappedProducts
      }
    />
  );
};
